import { useSelector } from 'react-redux';
import { getCurrency } from 'utils/currencyUtil';
import { getWalletTermsUrl } from './helper';

const useCreateWalletPage = () => {
  const currentCorporation = useSelector(state => state.user.currentCorporation);

  const country = currentCorporation?.country;
  const currency = getCurrency(country);
  const termsUrl = getWalletTermsUrl(country);
  const companyName = currentCorporation?.corporateClientName;

  return { currency, termsUrl, companyName };
};

export default useCreateWalletPage;
